import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import AccountsReceivable from "@/views/Accounting/AccountsReceivable.vue";
import Company from "@/views/Company/Form.vue";
import BranchesList from "@/views/Branches/List.vue";
import BranchForm from "@/views/Branches/Form.vue";
import CustomerList from "@/views/Customers/List.vue";
import CustomerForm from "@/views/Customers/Form.vue";
import GroupTripList from "@/views/GroupTrips/List.vue";
import GroupTripForm from "@/views/GroupTrips/Form.vue";
import GroupTripOrganize from "@/views/GroupTrips/Organize.vue";
import GroupTripAccounts from "@/views/GroupTrips/Accounts.vue";
import ContractForm from "@/views/Contracts/Form.vue";
import ContractList from "@/views/Contracts/List.vue";
import UserList from "@/views/Users/List.vue";
import UserForm from "@/views/Users/Form.vue";
import PrivacyPolicy from "./views/PrivacyPolicy.vue";
import Support from "./views/Support.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home //() => import("@/views/Home.vue")
    },
    {
      path: "/login",
      name: "login",
      component: Login //() => import("@/views/Home.vue")
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: PrivacyPolicy //() => import("@/views/Home.vue")
    },
    {
      path: "/support",
      name: "support",
      component: Support //() => import("@/views/Home.vue")
    },
    {
      path: "/about",
      name: "about",
      component: About //() => import("@/views/About.vue")
    },
    {
      path: "/company",
      name: "company",
      component: Company //() => import("@/views/About.vue")
    },
    {
      path: "/branches",
      name: "branch",
      component: BranchesList //() => import("@/views/About.vue")
    },
    {
      path: "/branch/:id?",
      name: "branch-form",
      component: BranchForm //() => import("@/views/About.vue")
    },
    {
      path: "/customers",
      name: "customer-list",
      component: CustomerList //() => import("@/views/About.vue")
    },
    {
      path: "/customer/:id?",
      name: "customer-form",
      component: CustomerForm //() => import("@/views/About.vue")
    },
    {
      path: "/grouptrips",
      name: "grouptrip-list",
      component: GroupTripList //() => import("@/views/About.vue")
    },
    {
      path: "/grouptrip/:id?",
      name: "grouptrip-form",
      component: GroupTripForm //() => import("@/views/About.vue")
    },
    {
      path: "/grouptrip/:id/organize",
      name: "grouptrip-organize",
      component: GroupTripOrganize //() => import("@/views/About.vue")
    },
    {
      path: "/grouptrip/:id/accounts",
      name: "grouptrip-accounts",
      component: GroupTripAccounts //() => import("@/views/About.vue")
    },
    {
      path: "/contracts",
      name: "contract-list",
      component: ContractList //() => import("@/views/About.vue")
    },
    {
      path: "/contract/:id?",
      name: "contract-form",
      component: ContractForm //() => import("@/views/About.vue")
    },
    {
      path: "/contract/for-customer/:customer_id",
      name: "contract-for-customer",
      component: ContractForm //() => import("@/views/About.vue")
    },
    {
      path: "/users",
      name: "user-list",
      component: UserList //() => import("@/views/About.vue")
    },
    {
      path: "/user/:id?",
      name: "user-form",
      component: UserForm //() => import("@/views/About.vue")
    },
    {
      path: "/accounting",
      name: "AccountsReceivable",
      component: AccountsReceivable
    }
  ]
});

router.beforeEach((to, from, next) => {
  const unsafeRoutes = ["login", "privacy-policy", "support"];
  if (
    !unsafeRoutes.includes(to.name) &&
    !router.app.$store.getters.isAuthenticated
  ) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
